import React from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';
import { IoIosPhonePortrait } from 'react-icons/io';
import Toast from 'modules/toast';

import RecordRTC from 'recordrtc';
import moment from 'moment';

import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

const captureUserMedia = (callback) => {
  const params = { audio: true, video: true };
  navigator.mediaDevices
    .getUserMedia(params)
    .then((mediaStream) => {
      callback(mediaStream);
      // console.log('Media stream?', mediaStream);
    })
    .catch((error) => {
      console.error(JSON.stringify(error));
      Toast.error('Error with video stream - possibly missing audio.');
    });
};

class MessagesVideoModal extends React.Component {
  static propTypes = {
    videoModalToggle: PropTypes.func.isRequired,
    isVideoModalOpen: PropTypes.bool.isRequired,
    myClient: PropTypes.object.isRequired,
    modalClassNames: PropTypes.string,
    refreshEverything: PropTypes.func.isRequired,
    title: PropTypes.string,
    fileUpload: PropTypes.func.isRequired,
  };

  static defaultProps = {
    title: 'Record Video For Client',
    modalClassNames: '',
  };

  constructor(props) {
    super(props);
    this.videoRecorderObj = null;
    this.videoPlayerRef = React.createRef();

    this.state = {
      isRecording: false,
      isRecordingPaused: false,
      isVideoRecorderObjCreated: false,
      playbackVideoSrc: null,
      recordedVideoParams: null,
      maxVideoTime: 900, // 900 seconds (15 mins) minutes max
      timerTime: 900,
    };
  }

  componentDidMount() {
    this.previewRecording();
  }

  componentWillUnmount() {
    this.closePreviewRecorder();
  }

  startTimer = () => {
    // timer logic
    this.timer = setInterval(() => {
      const newTime = this.state.timerTime - 1;
      if (newTime >= 0) {
        this.setState({
          timerTime: newTime,
        });
      } else {
        clearInterval(this.timer);
        this.stopRecord();
      }
    }, 1000);
  };

  stopTimer = () => {
    // clear timer interval & reset timer
    clearInterval(this.timer);
  };

  resetTimer = () => {
    // reset timer to starting time
    this.setState({ timerTime: this.state.maxVideoTime });
  };

  displayTimer = () => {
    const secondsRemaining = `0${
      Math.floor(this.state.timerTime % 60) % 60
    }`.slice(-2);
    const minutesRemaining = `0${Math.floor(
      (this.state.timerTime / 60) % 60,
    )}`.slice(-2);

    const timeElapsed = this.state.maxVideoTime - this.state.timerTime;
    const secondsElapsed = `0${Math.floor(timeElapsed % 60) % 60}`.slice(-2);
    const minutesElapsed = `0${Math.floor((timeElapsed / 60) % 60)}`.slice(-2);

    return `Time elapsed: ${minutesElapsed}:${secondsElapsed}\n
    Time left for video: ${minutesRemaining}:${secondsRemaining}`;
  };

  startRecord = () => {
    console.devLog.info('Starting recording');

    captureUserMedia((stream) => {
      this.videoPlayerRef.current.srcObject = stream;
      this.videoPlayerRef.current.muted = true;
      this.videoPlayerRef.current.volume = 0;
      this.videoRecorderObj = RecordRTC(stream, {
        type: 'video',
        canvas: {
          width: 640,
          height: 480,
        },
        mimeType: 'video/webm;codecs=h264',
        bitrate: 500000,
        videoBitsPerSecond: 500000,
        frameInterval: 15,
      });

      this.videoRecorderObj.startRecording();
    });

    this.startTimer();
    this.setState({
      isRecording: true,
      isVideoRecorderObjCreated: true,
      playbackVideoSrc: null,
    });
  };

  pauseRecording = () => {
    if (!this.videoRecorderObj) {
      throw new Error('No recorder object active');
    }
    this.stopTimer();
    this.videoRecorderObj.pauseRecording();
    this.setState({ isRecordingPaused: true });
    console.devLog.info('Paused recording.');
  };

  resumeRecording = () => {
    if (!this.videoRecorderObj) {
      throw new Error('No recorder object active');
    }
    this.startTimer();
    this.videoRecorderObj.resumeRecording();
    this.setState({ isRecordingPaused: false });
    console.devLog.info('Resumed recording.');
  };

  previewRecording = () => {
    captureUserMedia((stream) => {
      this.videoPlayerRef.current.srcObject = stream;
      this.videoPlayerRef.current.muted = true;
      this.videoPlayerRef.current.volume = 0;
      this.videoRecorderObj = RecordRTC(stream, {
        type: 'video',
        canvas: {
          width: 640,
          height: 480,
        },
        mimeType: 'video/webm;codecs=h264',
        bitrate: 500000,
        videoBitsPerSecond: 500000,
        frameInterval: 15,
      });

      this.videoRecorderObj.startRecording();
    });
    this.setState({
      isVideoRecorderObjCreated: true,
      playbackVideoSrc: null,
    });
  };

  stopRecord = () => {
    this.stopTimer();
    this.resetTimer();
    this.videoRecorderObj.stopRecording(() => {
      const params = {
        type: 'video/webm',
        data: this.videoRecorderObj.blob,
        id: `nf-twa-${moment().format('ddd-MMM-Do-h:mm-a')}.webm`,
      };
      this.videoPlayerRef.current.muted = false;
      this.videoPlayerRef.current.volume = 1;
      this.videoPlayerRef.current.srcObject.getTracks().forEach((track) => {
        track.stop();
      });
      // this.videoPlayerRef.current.src = this.videoRecorderObj.toURL();
      this.setState({
        playbackVideoSrc: this.videoRecorderObj.toURL(),
        recordedVideoParams: params,
      });
      console.devLog.info('recording stopped');
      this.videoRecorderObj.destroy();
      this.setState({ isRecording: false, isVideoRecorderObjCreated: false });
    });
  };

  closePreviewRecorder = () => {
    if (!this.state.playbackVideoSrc) {
      this.videoPlayerRef.current.srcObject.getTracks().forEach((track) => {
        track.stop();
      });
    }
  };

  // save to disk functionality
  saveVideo = () => {
    const link = document.createElement('a');
    document.body.appendChild(link);
    link.style = 'display: none';

    const url = this.state.playbackVideoSrc;
    link.href = url;
    link.download = `nf-twa-${moment().format('ddd-MMM-Do-h:mm:ss-a')}.webm`;
    link.click();
    URL.revokeObjectURL(url);
  };

  sendVideo = async () => {
    const params = this.state.recordedVideoParams;
    const file = new File([params.data], params.id, {
      type: 'video/webm;codecs=h264',
    });
    this.saveVideo(); // save the video first just to make sure trainer has it
    this.hideModal();
    await this.props.fileUpload(file);
    this.props.refreshEverything();
  };

  hideModal = () => {
    $('#video-modal').modal('hide');
    this.props.videoModalToggle();
  };

  render() {
    return (
      <Modal
        isOpen={this.props.isVideoModalOpen}
        toggle={this.props.videoModalToggle}
        className={this.props.modalClassNames}
      >
        <ModalHeader toggle={this.hideModal}>{this.props.title}</ModalHeader>
        <ModalBody>
          <div className="d-flex justify-content-center">
            {!this.state.playbackVideoSrc && (
              // No need for captions on this media
              // eslint-disable-next-line
              <video
                ref={this.videoPlayerRef}
                controls
                autoPlay
                playsInline
                className="video-feed"
              />
            )}
            {this.state.playbackVideoSrc && (
              // No need for captions on this media
              // eslint-disable-next-line
              <video
                controls
                playsInline
                src={this.state.playbackVideoSrc}
                className="video-feed"
              />
            )}
          </div>
          <div className="mt-2" style={{ whiteSpace: 'pre-line' }}>
            {this.displayTimer()}
          </div>
        </ModalBody>
        <ModalFooter className="justify-content-between">
          <div>
            {this.props.myClient.data[0].chatMedium === 2 && (
              <div>
                <span>
                  <IoIosPhonePortrait />
                  SMS
                </span>
              </div>
            )}
            {!this.state.isRecording && (
              <button
                type="button"
                className="btn btn-primary mr-2"
                onClick={this.startRecord}
              >
                Start Recording
              </button>
            )}
            {this.state.isRecording && (
              <button
                type="button"
                className="btn btn-primary mr-2"
                onClick={this.stopRecord}
              >
                Stop Recording
              </button>
            )}
            {this.state.isVideoRecorderObjCreated && (
              <>
                {this.state.isRecordingPaused ? (
                  <button
                    type="button"
                    className="btn btn-primary mr-2"
                    onClick={this.resumeRecording}
                  >
                    Resume Recording
                  </button>
                ) : (
                  <button
                    type="button"
                    className="btn btn-primary mr-2"
                    onClick={this.pauseRecording}
                  >
                    Pause Recording
                  </button>
                )}
              </>
            )}
          </div>
          <div>
            {this.state.playbackVideoSrc && (
              <>
                <button
                  type="button"
                  className="btn btn-primary mr-2"
                  onClick={this.sendVideo}
                >
                  Send Video
                </button>
              </>
            )}
            <button
              type="button"
              className="btn btn-secondary"
              data-dismiss="modal"
              onClick={this.hideModal}
            >
              Close
            </button>
          </div>
        </ModalFooter>
      </Modal>
    );
  }
}

export default MessagesVideoModal;
